let slideIndex = 1;
let mobileSlideIndex=1;

// The hero now shows all panels side by side (3-panel split layout), so
// slides are no longer hidden/shown one at a time. plusSlides/currentSlide
// instead scroll the panel row, keeping the same function names the
// existing onclick attributes call.
showSlidesMobile(mobileSlideIndex);


// Next/previous controls
function plusSlides(n) {
  const track = document.querySelector(".top-banner-wrapper .main-slider");
  if (!track) return;
  const panel = track.querySelector("a");
  const panelWidth = panel ? panel.getBoundingClientRect().width : track.clientWidth / 3;
  track.scrollBy({ left: n * panelWidth, behavior: "smooth" });
}

// Thumbnail image controls: scroll the panel row to the n-th panel.
function currentSlide(n) {
  slideIndex = n;
  const track = document.querySelector(".top-banner-wrapper .main-slider");
  if (!track) return;
  const panels = track.querySelectorAll("a");
  const target = panels[n - 1];
  if (target) target.scrollIntoView({ behavior: "smooth", inline: "start", block: "nearest" });
}

// Keep the dots highlighted to reflect which panel is currently in view.
(function syncHeroDots() {
  const track = document.querySelector(".top-banner-wrapper .main-slider");
  if (!track) return;
  const dots = document.querySelectorAll(".top-banner-wrapper .custom-index-slideshow-dot");
  const panels = track.querySelectorAll("a");
  if (!dots.length || !panels.length) return;

  const setActive = (index) => {
    dots.forEach((dot, i) => {
      dot.classList.toggle("custom-index-slideshow-active", i === index);
    });
  };

  let ticking = false;
  track.addEventListener("scroll", () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const trackRect = track.getBoundingClientRect();
      let closest = 0;
      let closestDist = Infinity;
      panels.forEach((panel, i) => {
        const dist = Math.abs(panel.getBoundingClientRect().left - trackRect.left);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });
      setActive(Math.min(closest, dots.length - 1));
      ticking = false;
    });
  });

  setActive(0);
})();







// Next/previous controls
function plusSlidesMobile(n) {
  
  showSlidesMobile(mobileSlideIndex += n);
}

// Thumbnail image controls
function currentSlideMobile(n) {
  showSlidesMobile(mobileSlideIndex = n);
}


function showSlidesMobile(n) {
  let i;
  let slides = document.getElementsByClassName("mobile-slide");
  let dots = document.getElementsByClassName("mobile-slide-show-dots");
  if (n > slides.length) {mobileSlideIndex = 1}
  if (n < 1) {mobileSlideIndex = slides.length}

  console.log("i="+i);
  console.log("length slides:"+slides.length);
  console.log("dots.length:"+dots.length);
  for (i = 0; i < slides.length; i++) {
    slides[i].style.display = "none";
  }
  for (i = 0; i < dots.length; i++) {
    dots[i].className = dots[i].className.replace(" mobile-custom-index-slideshow-active", "");
  }
  slides[mobileSlideIndex-1].style.display = "block";
  dots[mobileSlideIndex-1].className += " mobile-custom-index-slideshow-active";
}